<template>
  <div v-if="body_show" class="bodys">
    <public-header :colors="'#f0f0f0'" :headimg="data.headimg"></public-header>
    <div class="report_main_b" v-if="data.score!=''">
      <h3>《个人战略》项目学习报告</h3> {{data.score}}
    </div>
    <div class="report_main">
      <div v-for="(item,index) in data.report" :key="index">
        <img :src="item" class="report_img" @click="img_preview(index)" />
        <h5>*长按卡片可保存</h5>
      </div>
    </div>
  </div>
</template>
<script>
import {
  tactic_report
} from "@/api/course";
import {
  ImagePreview
} from 'vant';
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        cid: "",
        data: {},
        body_show: false
      }
    },
    methods: {
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        this.cid = this.$route.query.cid;
        tactic_report({
            cid: this.cid
          })
          .then((data) => {
            this.$toast.clear();
            document.title = data.title;
            this.data = data;
            this.body_show = true;
          })

      },
      img_preview(num) {
        ImagePreview({
          images: this.data.report,
          startPosition: num,
          showIndex: false,
          onClose() {
            // do something
          }
        });
      }
    },
    created() {
      this.pullData();
      shareCon("course",this);
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.bodys {
  padding-bottom: 55px
}

.report_main_b {
  background: url(../../../assets/score_b.png) no-repeat top center;
  background-size: cover;
  width: 100%;
  height: changeRem(10.2) + px;
  position: relative;
  text-align: center;
  padding-top: changeRem(7.46) + px;
  color: #EB5032;
  font-size: changeRem(.6) + px;
  line-height: changeRem(.65) + px;
  h3 {
    position: absolute;
    top: changeRem(.8) + px;
    left: changeRem(.6) + px;
    color: #fff;
    font-size: changeRem(.68) + px;
    margin-top: 0;
  }
}

.report_main {
  background: #fff;
  text-align: left;
  img.report_img {
    width: 100%;
    height: auto;
    vertical-align: middle;
  }
  h5 {
    color: #333;
    font-size: changeRem(.48) + px;
    padding-right: changeRem(.6) + px;
    text-align: right;
  }
}
</style>
